export default __webpack_public_path__ + "static/media/bc-five.4c70b112.svg";